import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { CreateEditingStyleInput } from '../../types';
import { Translate } from '../../../../shared/LanguageService';
import { useCreateEditingStyleForm } from '../state/useCreateEditingStyleForm';
import { whiteNotchedOutline } from '../../../../shared/whiteNotchedOutline';

type CreateEditingStyleModalProps = {
    open: boolean;
    onClose: () => void;
    onCreateSave: (input: CreateEditingStyleInput) => void;
};

type CreateEditingStyleFormProps = {
    onClose: () => void;
    onCreateSave: (input: CreateEditingStyleInput) => void;
};

function CreateEditingStyleForm({ onClose, onCreateSave }: CreateEditingStyleFormProps) {
    const { canCreate, handleChange, handleSubmit } = useCreateEditingStyleForm({
        onCreateSave,
        onClose
    });

    return (
        <form onChange={handleChange} onSubmit={handleSubmit}>
            <DialogTitle>{Translate('editing-styles/modal/title-create')}</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2} sx={{ pt: 1, ...whiteNotchedOutline }}>
                    <TextField
                        name="name"
                        label={Translate('editing-styles/modal/field/name')}
                        required
                        fullWidth
                    />
                    <TextField
                        name="description"
                        label={Translate('editing-styles/modal/field/description')}
                        multiline
                        minRows={3}
                        fullWidth
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button type="button" onClick={onClose}>
                    {Translate('editing-styles/modal/button/cancel')}
                </Button>
                <Button type="submit" variant="contained" disabled={!canCreate}>
                    {Translate('editing-styles/modal/button/create')}
                </Button>
            </DialogActions>
        </form>
    );
}

export function CreateEditingStyleModal({ open, onClose, onCreateSave }: CreateEditingStyleModalProps) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <CreateEditingStyleForm onClose={onClose} onCreateSave={onCreateSave} />
        </Dialog>
    );
}
